// Slick Carousel
import Glide from "@glidejs/glide";

class CarouselHeroCaption {
  constructor() {
    // element that will be wrapped
    const carousel = document.querySelector(".carousel-hero-caption");
    carousel.style.backgroundColor = "#000"; // Set background color of carousel to black

    if (carousel) {
      const carouselTrack = document.querySelector(
        ".carousel-hero-caption .wp-block-group"
      );
      const carouselSlides = carouselTrack.querySelector(
        ".carousel-hero-caption .wp-block-group .wp-block-group"
      );
      const carouselIndividualSlide = carouselTrack.querySelectorAll(
        ".carousel-hero-caption .wp-block-group .wp-block-group .wp-block-cover"
      );

      // Add Glide classes
      carouselTrack.classList.add("glide__track");
      carouselTrack.dataset.glideEl = "track";
      carouselSlides.classList.add("glide__slides");
      carouselIndividualSlide.forEach((item) => {
        item.classList.add("glide__slide");
        item.style.transition = "opacity 1s"; // Add transition style
      });

      // Tweak styles
      carousel.style.overflow = "hidden";
      carouselSlides.style.flexWrap = "nowrap";

      var fullWidthGlide = new Glide(".carousel-hero-caption", {
        type: "carousel",
        perView: 1,
        autoplay: 3000,
        peek: 0,
        gap: 0,
        animationDuration: 0,
      }).mount();

      // Adjust opacity of slides
      fullWidthGlide.on('move', function() {
        carouselIndividualSlide.forEach((item) => {
          item.style.opacity = 0.1;
        });
      });

      fullWidthGlide.on('move.after', function() {
        carouselIndividualSlide[fullWidthGlide.index].style.opacity = 1;
      });
    }
  }
}

export default CarouselHeroCaption;
